<template>
  <div class="detail-warpper">
    <div class="header">
      <div class="iconfont icon-fanhui2" @click="goBack"></div>
      <div class="header-text">社工详情</div>
    </div>
    <div class="content-warpper">
      <!-- 左侧用户信息 -->
      <div class="userInfo">
        <!-- 用户信息面板 -->
        <div class="userPanel">
          <div class="avastar">
            <img
              width="100%"
              height="100%"
              :src="userInfo.headPicUrl||require('@/assets/images/photo.png')"
              title="头像"
            />
          </div>
          <div class="nickName">{{userInfo.realName||userInfo.workerName}}</div>
          <!-- 认证状态 -->
          <div class="authState noAuth" v-if="userInfo.realNameStatus==0">
            <span class="noAuthIcon"></span>
            <span class="auth-text">未认证</span>
          </div>
          <div class="authState authed" v-if="userInfo.realNameStatus==1">
            <Icon type="ios-checkmark-circle" size="16" />
            <span class="auth-text">审核通过</span>
          </div>
          <div class="authState authing" v-if="userInfo.realNameStatus==-1">
            <!-- <Icon type="ios-close-circle" size="16"/> -->
            <span class="noAuthIcon authingIcon"></span>
            <!-- noAuthIcon 的名字没有改 -->
            <span class="auth-text">待审核</span>
          </div>
          <!-- 用户分类 -->
          <!-- <div class="source">冰糖葫芦</div> -->
          <!-- 贡献与排名 -->
          <div class="rankBoard" v-for="item in userInfo.scoreMap" :key="item.id">
            <div class="contribute">
              <span class="contribute-text">社区积分</span>
              <span class="contribute-num">{{item.score/100}}</span>
            </div>
            <div class="rank">
              <span class="rank-text">排名</span>
              <span class="rank-num">{{item.rank}}/{{item.total}}</span>
            </div>
          </div>
        </div>
        <div class="baseInfo">
          <baseinfo
            class="baseinfo-item"
            v-for="(item,index) in workerInfo"
            :edit="item.edit"
            :ref="item.name"
            :key="index"
            :title="item.title"
            :infoValue="item.infoValue"
            :model="item.model"
            :placeholder="item.placeholder"
            :selectList="item.selectList"
            :currentId="item.currentId"
          ></baseinfo>
        </div>
        <!-- 审核按钮 -->
        <!-- <div class="verifyButton" v-if="userInfo.realNameStatus==-1">
          <Button type="success" small class="button pass" @click="submitBaseInfo(1)">审核通过</Button>
          <Button type="error" small class="button nopass" @click="submitBaseInfo(0)">审核不通过</Button>
        </div>-->
        <!-- 编辑按钮 -->
        <div class="edit-box">
          <!-- 2018年12月27日 审核通过接口 -->
          <transition name="cancel-fade">
            <div v-show="edit" @click="exitEdit" class="edit-btn cancel">取消</div>
          </transition>
          <div class="edit-btn" @click="toEdit">{{edit?'保存':'编辑'}}</div>
          <div
            class="edit-btn"
            style="background: #f44241"
            v-if="userInfo.realNameStatus == -1"
            @click="shenhe(0)"
          >审核不通过</div>
          <div
            class="edit-btn"
            style="background: #47ba54"
            v-if="userInfo.realNameStatus == -1 || userInfo.realNameStatus == 0"
            @click="shenhe(1)"
          >审核通过</div>
        </div>
      </div>
      <!-- 右侧用户事件 -->
      <div class="userEvent">
        <eventcard class="icard" :obj="eventList"></eventcard>
        <!-- <eventcard class="icard" :obj="eventList"></eventcard>
        <eventcard class="icard" :obj="eventList"></eventcard>-->
      </div>
    </div>
  </div>
</template>

<script>
import baseinfo from "./components/baseInfo";
import eventcard from "./components/eventCard";
import { Promise } from "q";
export default {
  mounted() {
    this.unionId = this.$route.params.unionId || sessionStorage.workUnionId; // 刷新时读取
    this.communityId =
      this.$route.params.communityId || sessionStorage.workcommunityId;
    sessionStorage.workcommunityId = this.communityId;
    this._storeUnionid(this.unionId); // 第一进来 存储unionid
    this.getDetail();
    this.getOrgList();
  },
  data() {
    return {
      communityId: "",
      userInfo: {},
      // unionId: "o8vyu0ZI3tEbONFwmzPKa_z9MCu4",
      unionId: "",
      edit: false, // 控制 本组件的编辑模式
      eventList: {
        header: "参加活动",
        number: "15",
        dataList: []
      },
      workerInfo: []
    };
  },
  methods: {
    // 返回
    goBack() {
      this.$router.go(-1);
    },
    /* 获取社工详情 */
    getDetail() {
      let url = this.urlobj.workerDetail(this.unionId);
      this.$store.commit("updateSpinShow", true);
      this.$get(url, {
        communityId: this.communityId
      })
        .then(res => {
          this.$store.commit("updateSpinShow", false);
          if (res.isSucceed) {
            let u = res.rows[0];
            let _scoreMap = [];
            _scoreMap.push(u.scoreInfo);
            /* 过滤数据 */
            this.userInfo = {
              headPicUrl: u.headPicUrl, // 头像
              idCardNO: u.idCardNO, // 身份证号
              phoneNO: u.phoneNO, // 手机号
              realName: u.realName, // 认证姓名
              realNameStatus: u.realNameStatus, // 认证状态
              workerName: u.workerName, // 微信昵称
              scoreMap: _scoreMap, // 贡献排名
              unionId: u.unionId
              // zoneList: u.zoneList // 社区 或 支部 信息
            };
            this.getRealnameDetail();
            /* 初始化编辑模式 */
            // if (u.realNameStatus == -1) {
            //   this.toEdit();
            // }
          }
        })
        .catch(e => console.log(e));
    },
    /* 获取社区企业选择列表 */
    getOrgList() {
      let url = this.urlobj.belongList();
      this.$get(url, {
        isContainsCompany: 1, // 包含 企业列表,
        communityId: this.communityId
      })
        .then(res => {
          if (res.isSucceed && res.rows.length > 0) {
            // 社区企业的选择列表
            this.org = res.rows.map(item => {
              return {
                value: item.companyId,
                label: item.name
              };
            });
          }
        })
        .catch(e => console.log(e));
    },
    /* 进入编辑模式 */
    toEdit() {
      /* 判断之前的模式 如果再编辑模式则是保存*/
      if (this.edit) {
        this.submitBaseInfo();
      } else {
        /* 不是编辑模式 进入编辑模式 */
        this.edit = true;
        /* 每个对象都进去编辑模式 */
        this.workerInfo.forEach(item => {
          item.edit = true;
        });
      }
    },
    /* 退出编辑模式 */
    exitEdit() {
      this.edit = false;
      /* 每个对象都退出编辑模式 */
      this.workerInfo.forEach(item => {
        item.edit = false;
      });
    },
    /* 提交审核 或者 保存 */
    submitBaseInfo(state) {
      var baseInfo = this.workerInfo.map(item => {
        let name = item.name;
        if (item.inputtype == 0) {
          item.dataValue = this.$refs[name][0].getValue() || "";
        }
        if (item.inputtype == 1) {
          item.dataValue = this.$refs[name][0].getSelectedId() || "";
        }
        return item;
      });
      let data1 = []
      baseInfo.forEach(item => {
        if (item.inputtype == 0) {
          data1.push({
            fieldValue: item.name,
            dataValue: item.dataValue
          });
        }
        if (item.inputtype == 1) {
          data1.push({
            fieldValue: item.name,
            dataValue: item.dataValue ? [{ id: item.dataValue }] : []
          });
        }
      });
      let data = {
        unionId: this.unionId,
        communityId: this.communityId,
        fieldData: [...data1]
      };
      this.$post(this.urlobj.applyRealname('worker'), data)
        .then(res => {
          this.$Message.success("操作成功");
          this.getDetail();
          this.exitEdit();
          this.loading = false;
        })
        .catch(e => {
          this.loading = false;
        });
      console.log(data);
    },
    /* @state 1 审核通过  0审核未通过 */
    pass(state) {
      // 组织基本数据
      let data = {
        unionId: this.unionId,
        realNameStatus: state,
        realName: this.$refs.name[0].getValue() || "",
        phoneNO: this.$refs.phone[0].getValue() || "",
        idCardNO: this.$refs.idCard[0].getValue() || ""
      };
      // 工作单位 或者 社区
      let currentId = this.$refs.org[0].getSelectedId().split("-");
      data[currentId[1]] = currentId[0];

      // 姓名校验
      if (!data.realName) {
        this.$Message.info("姓名不能为空");
        return;
      }
      // 手机号校验
      let checkPhone = this.$util.validatemobile(data.phoneNO);
      if (!checkPhone.result) {
        this.$Message.info(checkPhone.message);
        return;
      }
      // 添加身份证号校验
      // let checkIdNo = this.$util.IdentityCodeValid(data.idCardNO)
      // if (!checkIdNo.result) {
      //   this.$Message.warning(checkIdNo.message)
      //   return
      // }
      // 身份证长度校验
      if (data.idCardNO.length === 0) {
        this.$Message.info("身份证长度不能为空");
        return;
      }

      return new Promise((resolve, reject) => {
        let url = this.urlobj.workerCheck();
        this.$post(url, data)
          .then(res => {
            if (res.isSucceed) {
              this.$Message.success("操作成功");
              resolve(res);
            }
          })
          .catch(e => console.log(e));
      });
    },
    /* 更新用户属性 */
    updateUserAttr() {
      // 1. 组织数据
      let data = {
        unionId: this.unionId,
        position: this.$refs.position[0].getValue() || "",
        workContent: this.$refs.workContent[0].getValue() || ""
      };
      let url = this.urlobj.updateUserAttr;
      return new Promise(resolve => {
        this.$post(url, data).then(res => {
          resolve(res);
        });
      });
    },
    /* 更新基础信息的对象数据或者对象树形数据 */
    _initBaseInfoObj(obj, prop, value) {
      if (prop) {
        this.baseInfoObj[obj][prop] = value;
      } else {
        this.baseInfoObj[obj] = value;
      }
    },
    _storeUnionid(u) {
      sessionStorage.workUnionId = u;
    },
    getRealnameDetail() {
      var url = this.urlobj.getAuth("worker");
      var data = {
        unionId: this.unionId,
        communityId: this.communityId
      };
      this.$get(url, data).then(res => {
        var baseinfo = [];
        /**基本信息表单处理 */
        res.rows.forEach(item => {
          if (item.fieldType) {
            if (item.inputType == 0) {
              baseinfo.push({
                name: item.fieldValue,
                title: item.fieldName,
                edit: false,
                infoValue: item.dataValue ? item.dataValue : "",
                inputtype: item.inputType,
                model: "input",
                placeholder: "请输入"
              });
            }
            if (item.inputType == 1) {
              baseinfo.push({
                name: item.fieldValue,
                title: item.fieldName,
                multiple: false,
                edit: false,
                infoValue:
                  item.dataValue && item.dataValue.length
                    ? item.dataValue[0].value
                    : "暂无数据",
                model: "select",
                placeholder: "请选择",
                currentId:
                  item.dataValue && item.dataValue.length
                    ? item.dataValue[0].id
                    : "",
                selectList: this.org,
                inputtype: item.inputType
              });
            }
          }
        });
        /**基本信息表单处理结束 */
        this.workerInfo = baseinfo;
      });
    },
    shenhe(status) {
      let url = this.urlobj.shenheAll("worker");
      let data = {
        status,
        unionIds: this.unionId,
        communityId: this.communityId
      };
      this.$post(url, data).then(res => {
        this.$Message.success("操作成功");
        this.getDetail();
        this.exitEdit();
      }).catch(e=>{
        this.$Message.success("操作失败");
      });
    },
  },
  computed: {
    baseInfo() {
      return this.$util.mapObj(this.baseInfoObj, item => item);
    }
  },
  components: {
    baseinfo,
    eventcard
  }
};
</script>

<style lang='less' scoped>
.mb20 {
  margin-bottom: 18px;
}
.mb30 {
  margin-bottom: 22px;
}

.detail-warpper {
  height: 100%;
  display: flex;
  flex-direction: column;
}
/* 头部标题 */
.header {
  width: 98%;
  margin: 30px auto;
  display: grid;
  grid-template-columns: 30px auto 30px;
  font-size: 25px;
  color: #666;
  .header-text {
    justify-self: center;
    align-self: center;
  }
  .icon-fanhui2 {
    font-size: 25px;
    color: #666;
    justify-self: center;
    align-self: center;
    cursor: pointer;
  }
}
/* -----------------------------市民详情-------------------------------- */
.content-warpper {
  flex: 1;
  width: 98%;
  margin: 0 auto;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
}
/* =========== 用户信息框 ==========*/
.content-item {
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 30px;
}
.userInfo {
  position: relative;
  min-width: 392px;
  max-width: 392px;
  max-height: 100%;
  background-color: #fff;
  margin-right: 20px;
  // 保证自适应之后的边距
  .content-item;
}
/* 编辑按钮 */
.edit-box {
  display: flex;
  justify-content: flex-end;
  width: 92%;
  margin: 30px auto;
}
.edit-btn {
  height: 28px;
  line-height: 28px;
  width: 90px;
  text-align: center;
  background-color: #ff7b43;
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
  margin-left: 20px;
}
/* 取消按钮 */
.cancel {
  margin-left: 10px;
  background-color: transparent;
  color: #333;
}
/* 过渡动画 */
.cancel-fade-enter-active,
.cancel-fade-leave-active {
  transition: opacity 0.5s;
}
.cancel-fade-enter,
.cancel-fade-leave-to {
  opacity: 0;
}
.userPanel {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 30px;
  & .avastar {
    width: 96px;
    height: 96px;
    border-radius: 50%;
    border: 1px solid #ccc;
    .mb20;
    & > img {
      border-radius: 100%;
    }
  }
  & .nickName {
    font-size: 20px;
    font-weight: 600px;
    color: #4c4c4c;
    .mb20;
  }
  & .authState {
    display: flex;
    align-items: center;
    border: 1px solid #333;
    padding: 2px 10px;
    border-radius: 15px;
    .mb30;
  }
  & .noAuth {
    border-color: #a3aeb2;
    color: #a3aeb2;
  }
  /* 未认证的图标 */
  .noAuthIcon {
    position: relative;
    display: inline-block;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background-color: #a3aeb2;
    &::after {
      content: "...";
      position: absolute;
      top: 20%;
      left: 50%;
      transform: translateX(-50%);
      line-height: 0;
      color: #fff;
    }
  }
  & .authed {
    color: #47b804;
    border-color: #47b804;
  }
  & .authing {
    color: #ff7b43;
    border-color: #ff7b43;
    & > .authingIcon {
      background-color: #ff7b43;
    }
  }
  & .auth-text {
    margin-left: 10px;
  }
}
/* 来源 */
.source {
  .mb30;
}
/* 用户贡献度 排名 */
.rankBoard {
  display: flex;
  align-items: center;
  .mb30;
}
/* 积分排名 */
.contribute {
  padding-left: 20px;
  margin-right: 50px;
  border-left: 3px solid #fe7b43;
}
.contribute-text {
  font-size: 18px;
  color: #4b4b4b;
  margin-right: 20px;
}
.contribute-num {
  font-size: 20px;
  font-weight: 600;
  color: #4b4b4b;
}
/* 排名 */
.rank-text {
  font-size: 18px;
  color: #fe7b43;
  margin-right: 20px;
}
.rank-num {
  font-size: 20px;
  font-weight: 600;
  color: #fe7b43;
}
/* 用户基本信息 */
.baseInfo {
  width: 92%;
  margin: 0 auto;
}
.baseinfo-item {
  margin-bottom: 20px;
}
/* 审核 按钮 */
.verifyButton {
  display: flex;
  justify-content: flex-end;
  width: 92%;
  margin: 30px auto;
}
.button {
  margin-left: 10px;
}
/* 用户事件 */
.userEvent {
  flex: 1;
  // background: #fff;
  //  保持宽屏时底边距统一
  .content-item;
  border: none;
}
.icard {
  margin-bottom: 20px;
}
.icard:last-child {
  margin-bottom: 0px;
}
</style>

